<template>
	<div>

		<el-form :inline="true">
			<el-form-item>
				<el-button type="primary" @click="dialogVisible = true">新增</el-button>
			</el-form-item>
		</el-form>

		<el-table
				:data="tableData"
				style="width: 100%;margin-bottom: 20px;margin-top: -10px;"
				:height="tableHeight"
				:row-style="{height: '20px'}"
				:cell-style="{padding: '0'}"
				:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
				row-key="id"
				border
				stripe
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">

			<el-table-column
					prop="locationName"
					label="位置名称"
					width="300">
			</el-table-column>

			<el-table-column
					prop="locationNo"
					label="位置编号"
					width="180">
			</el-table-column>

			<el-table-column
					prop="fullName"
					label="位置全称"
					width="500"
					show-overflow-tooltip >
			</el-table-column>

			<el-table-column
					prop="updateTime"
					label="修改时间">
			</el-table-column>

			<!-- <el-table-column
					prop="userNickName"
					label="操作员">
			</el-table-column> -->

			<el-table-column
					prop="icon"
					label="操作">

				<template slot-scope="scope">
					<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
					<el-divider direction="vertical"></el-divider>

					<template>
						<el-popconfirm title="确定删除该位置吗？" @confirm="delHandle(scope.row.id)">
							<el-button type="text" slot="reference">删除</el-button>
						</el-popconfirm>
					</template>

				</template>
			</el-table-column>

		</el-table>


		<!--新增对话框-->
		<el-dialog
				title="提示"
				:visible.sync="dialogVisible"
				width="600px"
				:before-close="handleClose"
				:close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<el-form-item label="上级位置" prop="parentId" label-width="100px">
					<el-select v-model="editForm.parentId" placeholder="请选择上级位置" >
						<el-option 
						:value="editForm.parentId"
              			:label="editForm.parentFullName"
						style="width: 460px;height: 200px;overflow: auto;background-color: #fff;">
							<LocationTree @getTreeData="locationSelectNodeClick"/>
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="位置名称" prop="locationName" label-width="100px">
					<el-input v-model="editForm.locationName" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="位置编号" prop="locationNo" label-width="100px">
					<el-input v-model="editForm.locationNo" autocomplete="off"></el-input>
				</el-form-item>

				<!-- <el-form-item>
					<el-button type="primary" @click="submitForm('editForm')">保存</el-button>
					<el-button @click="resetForm('editForm')">重置</el-button>
				</el-form-item> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>


	</div>

</template>

<script>
	import LocationTree from "../base/LocationTree.vue"
	export default {
		name: "Location",
		components:{LocationTree},
		data() {
			return {
				dialogVisible: false,
				editForm: {

				},
				editFormRules: {
					parentId: [
						{required: true, message: '请选择上级位置', trigger: 'blur'}
					],
					locationName: [
						{required: true, message: '请输入位置名称', trigger: 'blur'}
					]
				},
				tableData: []
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 710: 580
			}
		},
		created() {
			this.getLocationTree()
		},
		methods: {
			getLocationTree() {
				this.$axios.get("/base/location/list").then(res => {
					this.tableData = res.data.data
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$axios.post('/base/location/' + (this.editForm.id?'update' : 'save'), this.editForm)
							.then(res => {

								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success',
									onClose:() => {
										this.getLocationTree()
									}
								});

								this.dialogVisible = false
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			editHandle(id) {
				this.$axios.get('/base/location/info/' + id).then(res => {
					this.editForm = res.data.data

					this.dialogVisible = true
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},
			delHandle(id) {
				this.$axios.post("/base/location/delete/" + id).then(res => {
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose:() => {
							this.getLocationTree()
						}
					});

				})
			},
			locationSelectNodeClick(locationdata) {
				this.$set(this.editForm, "parentId", locationdata.id);
				this.$set(this.editForm, "parentFullName", locationdata.fullName);
				// console.log(deptdata);
			}
		}
	}
</script>

<style scoped>
.el-form-item .el-select {
    width: 100%;
  }
</style>